import { ThemeUICSSObject } from 'theme-ui';
import {
  getColorsAndStatesByPath,
  getColorsByPath,
} from '../../../../../methods';
import { responsive, spacing } from '../../../../../util';

const common: (type: string) => ThemeUICSSObject = (type) => ({
  ...getColorsByPath(type),
  gap: spacing(1),
  justifyContent: 'stretch',

  '&.onlyRefresh': {
    justifyContent: 'end',
  },
  alignItems: 'center',
  padding: 1,
  display: 'flex',

  '.pagination__leftToolbar': {
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  },
  '.pagination__deleteLabels': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '.pagination__selectPage': {
    width: '80px',
    top: '80px',
    textAlign: 'center',
  },

  '.iconButton': {
    height: '36px',
    width: '36px',

    ...getColorsAndStatesByPath(`${type}.icons`, {
      states: { disabled: false, path: false },
    }),
    '&:disabled': {
      background: 'transparent',
    },
  },
  '.recordsCounter': {
    color: 'palette.primary.contrastText',
    pl: spacing(3),
  },
  '.reachedMax': {
    color: 'red',
    pl: 2,
  },
  '.pagination__controls': {
    flexGrow: 1,
    justifyContent: 'center',
    flexShrink: 0,
    '&.onlyRefresh': {
      justifyContent: 'end',
    },
    alignItems: 'stretch',
    padding: 1,
    display: 'flex',
    width: responsive({ 0: 'max-content', 2: 'auto' }),

    'select ~ svg': {
      display: 'none',
    },

    '.input': {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(3),
      fontSize: '1em',
      border: '1px solid',
      paddingY: 1,
      paddingX: 4,
      ...getColorsByPath(`${type}.pagesBox`),
      input: {
        font: 'inherit',
        background: 'none',
        border: 'none',
        width: '30px',
        padding: 0,
        textAlign: 'center',
      },
      span: {
        font: 'inherit',
        display: 'block',
        width: '30px',
      },
    },
  },
  '.infoTooltip': {
    position: 'relative',
    display: 'inline-block',
    borderBottom: '1px dotted black',
    cursor: 'pointer',
    backgroundColor: '#f7d97f',
  },
  '.pagination__information': {
    p: 1,
    '.pagination__infoIcon': {
      display: 'flex',
    },
  },

  '.pagination__alertInfo': {
    variant: 'buttons.icon-primary',
    ...getColorsAndStatesByPath('buttons.iconAlert'),
  },
  '.pagination__rightToolbar': {
    display: 'flex',
    gap: 0,
    width: '100%',
    justifyContent: 'end',

    '.pagination__deleteFiltersButton': {
      variant: 'buttons.primary-sm',
      textDecoration: 'none',
      px: 3,
      '.button__content': {
        display: 'flex',
        flexDirection: 'row',
        gap: 3,
      },

      '.pagination__appliedFiltersLabel': {
        backgroundColor: 'palette.primary.contrastText',
        color: 'palette.text.title',
        borderRadius: '100%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '1.5em',

        '&.withFilters': {
          backgroundColor: 'favorite',
          color: 'palette.text.primary',
        },
      },
    },
  },
});

export default common;
